"use client";

import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function NosServices() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const services = [{
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/renovation_interieure.png",
    label: "Rénovation intérieure",
    delay: "0ms"
  }, {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/petits_travaux.png",
    label: "Petits travaux",
    delay: "150ms"
  }, {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/performance_energetique.png",
    label: "Performance énergétique",
    delay: "300ms"
  }];
  const refs = [ref1, ref2, ref3];
  const visibles = [isVisible1, isVisible2, isVisible3];
  return <section className="bg-background py-16 px-6">
      <div className="mx-auto max-w-7xl">
        <h2 className="mb-12 text-center text-4xl font-bold text-foreground">
          Nos services
        </h2>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {services.map((service, i) => <Card key={i} data-index={i} ref={refs[i]} className={`group overflow-hidden shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:scale-[1.04] hover:shadow-strong ${visibles[i] ? "translate-y-0 opacity-100" : "translate-y-[10px] opacity-0"}`} style={{
          transitionDelay: visibles[i] ? service.delay : "0ms"
        }}>
              <CardContent className="relative h-64 p-0">
                <img src={service.image} alt={service.label} className="h-full w-full object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-primary/90 via-primary/40 to-transparent transition-opacity duration-[var(--duration-medium)] group-hover:from-secondary/90 group-hover:via-secondary/40" />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="text-center text-2xl font-semibold text-foreground-primary drop-shadow-lg">
                    {service.label}
                  </span>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}